var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8061_2625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4181 0H12.5285V15.7212C12.5285 17.5944 11.0325 19.1331 9.17074 19.1331C7.30901 19.1331 5.813 17.5944 5.813 15.7212C5.813 13.8815 7.27577 12.3762 9.07102 12.3094V8.36236C5.11485 8.42923 1.92334 11.6738 1.92334 15.7212C1.92334 19.8021 5.18134 23.0801 9.204 23.0801C13.2266 23.0801 16.4846 19.7686 16.4846 15.7212V7.65989C17.9474 8.7303 19.7426 9.36583 21.6376 9.3993V5.45225C18.712 5.3519 16.4181 2.94354 16.4181 0Z",
    fill: "#C5CBDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8061_2625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.0801,
    height: 23.0801,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.f8eca1076c4cca740cdb5e7b5284f6f7.svg";
export { ForwardRef as ReactComponent };